import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Column, Search, Order, DataTableOutput, DataTableInput } from "@core/models/datables";
import { environment } from "environments/environment";
import { RegulationDetail } from "../models";

@Injectable({ providedIn: "root" })
export class RegulationDetailService {
    constructor(private _http: HttpClient) { }

    private columns: Column[] = [
        {
            data: "ingredient.name",
            name: "Ingrediente",
            searchable: true,
            orderable: true,
            search: new Search()
        },
        {
            data: "country.name",
            name: "Pais",
            searchable: true,
            orderable: true,
            search: new Search()
        },
        {
            data: "productCategory.name",
            name: "Categoria",
            searchable: true,
            orderable: true,
            search: new Search()
        },
        {
            data: "regulation.id",
            name: "Regulacion",
            searchable: true,
            orderable: true,
            search: new Search()
        },
        {
            data: "status.code",
            name: "status",
            searchable: true,
            orderable: true,
            search: { regex: false, value: "ACT" }
        }
    ];

    /**
     * Get all RegulationDetails
     * 
     */
    getAllRegulationDetails(page: number, quantity: number, order: Order, searchText: string) {
        this.columns[3].search = new Search()
        const input = this.createDataTableInput(page, quantity, order, searchText);
        return this._http.post<DataTableOutput<RegulationDetail>>(`${environment.rydApiUrl}/api/regulation-detail/index`, input);
    }

     getAllRegulationDetailsById(page: number, quantity: number, order: Order, searchText: string, regulationId: number) {
        this.columns[3].search = { regex: false, value: regulationId.toString() }
        const input = this.createDataTableInput(page, quantity, order, searchText);
        return this._http.post<DataTableOutput<RegulationDetail>>(`${environment.rydApiUrl}/api/regulation-detail/index`, input);
    }

    deleteRegulationDetail(id: number, statusId: number) {
        return this._http.put<any>(`${environment.rydApiUrl}/api/regulation-detail/delete/${id}/${statusId}`, null);
    }

    addRegulationDetail(regulation: RegulationDetail) {
        return this._http.post<any>(`${environment.rydApiUrl}/api/regulation-detail`, regulation);
    }

    editRegulationDetail(regulation: RegulationDetail) {
        return this._http.put<RegulationDetail>(`${environment.rydApiUrl}/api/regulation-detail/${regulation.id}`, regulation);
    }


    /**
    * Función que crea una entrada para datatable por medio de parametros
    * @param page Indica el número de página
    * @param quantity Indica la cantidad de unidades a solicitar
    * @param order Indica el orden que tendrá la columna
    * @param searchText Indica el texto que se va a filtrar
    * @returns Devuelve una entrada para datatable
    */
    private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput {
        let input = new DataTableInput();
        input.start = page * quantity;
        input.length = quantity;
        if (searchText !== '') {
            input.search.regex = true;
            input.search.value = searchText;
        }
        if (order) {
            input.order.push(order);
        }
        input.columns = this.columns;
        return input;
    }
}
